/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_VersionInputs */

const en_gc_editor_version = /** @type {(inputs: Gc_Editor_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0 · Alpha`)
};

const zh_gc_editor_version = /** @type {(inputs: Gc_Editor_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0 · Alpha`)
};

/**
* | output |
* | --- |
* | "GridCraft v0.7.0 · Alpha" |
*
* @param {Gc_Editor_VersionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_version = /** @type {((inputs?: Gc_Editor_VersionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_VersionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_version(inputs)
	return zh_gc_editor_version(inputs)
});
export { gc_editor_version as "gc.editor.version" }